import type { ReactNode } from 'react';
import { create } from 'zustand';

export interface ModalState {
  isOpen: boolean;
  view: () => ReactNode;
  openModal: (view: () => ReactNode) => void;
  closeModal: () => void;
}

const useModalStore = create<ModalState>(set => ({
  isOpen: false,
  view: null,

  openModal: view => set({ isOpen: true, view }),
  closeModal: () => set({ isOpen: false, view: null }),
}));

export default useModalStore;
